var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.detail.title))]),_c('div',{staticStyle:{"margin-top":"30px"},domProps:{"innerHTML":_vm._s(_vm.detail.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }